import { defineTheme } from '../utils'

export const wellness = defineTheme({
  languageButton: {
    base: 'rounded border p-2.5',
  },
  menuCategory: {
    title: 'font-[bebas-neue] text-2xl font-bold text-primary underline',
  },
  menuItem: {
    dinner: {
      base: 'relative z-2 grid grid-cols-[1fr_auto]',
      title: 'text-lg font-bold',
      priceList: 'text-right text-lg',
      description: 'order-2 col-span-2',
      icons: 'menu-icons order-3 mt-1',
      label: 'order-3 col-span-2 mt-2 w-full bg-secondary px-4 py-1.5 text-white',
    },
    drinks: {
      base: 'relative z-2 grid grid-cols-[1fr_auto]',
      title: 'text-lg font-bold',
      priceList: 'text-right text-lg',
      description: 'order-2 col-span-2',
      icons: 'menu-icons order-3 mt-1',
      label: 'order-3 col-span-2 mt-2 w-full bg-secondary px-4 py-1.5 text-white',

    },
  },
  menuSubCategory: {
    title: 'mb-2 font-bold text-secondary uppercase underline',
  },
  menuTitleBlock: {
    title: 'text-center font-[active] text-3xl text-primary uppercase lg:text-7xl',
  },
  page: {
    heading: 'text-center font-[active] text-3xl text-primary uppercase lg:text-7xl',
    menuHeading: 'underline',
  },
  themeLogo: {
    image: 'hidden',
  },
  filterBar: {
    bar: 'bg-secondary text-white',
    checkbox: 'accent-primary',
    closeButton: 'bg-primary text-white hover:bg-primary/60',
    masterItem: 'text-black',
    itemLabel: 'text-black',
    popoverTitle: 'text-white',
    popoverHeader: 'bg-secondary',
  },
})
